import { useCallback, useMemo } from 'react';
import { useAdminProfile } from '../contexts/AdminProfileContext';
import { ALL_PLATFORM_PERMISSIONS, ROUTE_VIEW_PERMISSION } from '../config/platform-permissions';

export function usePlatformPermissions() {
  const { admin, loading } = useAdminProfile();

  const permissions = useMemo(() => {
    if (admin?.has_full_access) return new Set(ALL_PLATFORM_PERMISSIONS);
    return new Set(admin?.permissions ?? []);
  }, [admin]);

  const can = useCallback(
    (key: string) => {
      if (!admin) return false;
      if (admin.has_full_access) return true;
      return permissions.has(key);
    },
    [admin, permissions],
  );

  const canAccessRoute = useCallback(
    (path: string) => {
      const viewKey = ROUTE_VIEW_PERMISSION[path];
      if (!viewKey) return true;
      return can(viewKey);
    },
    [can],
  );

  return { admin, loading, permissions, can, canAccessRoute };
}
